import React from 'react';
import { motion } from 'framer-motion';

const ElectricalSection = () => {
  const electricalProducts = [
    {
      name: 'Circuit Breaker',
      code: 'EL-201',
      type: '20A Single Pole',
      price: 'KSH 4,599',
      image: '/api/placeholder/300/300'
    },
    {
      name: 'LED Panel',
      code: 'EL-202',
      type: '2x4 ft',
      price: 'KSH 8,950',
      image: '/api/placeholder/300/300'
    },
    {
      name: 'Switch Outlet',
      code: 'EL-203',
      type: '15A Duplex',
      price: 'KSH 875',
      image: '/api/placeholder/300/300'
    },
    {
      name: 'Conduit Pipe',
      code: 'EL-204',
      type: '1/2" EMT',
      price: 'KSH 1,525',
      image: '/api/placeholder/300/300'
    }
  ];

  return (
    <section id="electrical" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-gray-800 mb-4">Electrical Equipment</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Reliable electrical components, wiring and safety equipment for all your projects.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {electricalProducts.map((product, index) => (
            <motion.div
              key={product.code}
              className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -8 }}
            >
              <div className="h-48 bg-gradient-to-br from-yellow-100 to-yellow-200 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-16 h-16 bg-yellow-500 rounded-lg mx-auto mb-2 flex items-center justify-center">
                    <span className="text-white font-bold text-lg">⚡</span>
                  </div>
                  <span className="text-yellow-600 text-sm font-medium">Electrical</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-2">{product.name}</h3>
                <div className="space-y-1 text-sm text-gray-600 mb-4">
                  <div>Code: {product.code}</div>
                  <div>Type: {product.type}</div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-yellow-600">{product.price}</span>
                  <motion.button
                    className="bg-yellow-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-yellow-700 transition-colors duration-300"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Add to Cart
                  </motion.button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ElectricalSection;
